import { useState, useEffect, useCallback } from 'react';
import qs from 'query-string';
import Immutable from 'immutable';
import { useHistory } from 'react-router';

import config from 'react-global-configuration';

import fromJSOrdered from '../../helpers/fromJsOrdered';
import { DEFAULT_LANGUAGE } from '../../config/constants';

const useQueryParameter = (param, defaultValue = '') => {
  const [queryParams, setQueryParams] = useState(defaultValue);
  const query = qs.parse(window.location.search);
  useEffect(() => {
    if (typeof query[param] !== 'undefined') {
      setQueryParams(query[param]);
    }
  }, [query, param]);

  return queryParams;
};

const useSearchApi = (searchIndex, searchPage = '/search', language = DEFAULT_LANGUAGE) => {
  const history = useHistory();
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(Immutable.Map());

  const currentQuery = useQueryParameter('q', '');
  const currentType = useQueryParameter('filter[type]', '');
  const currentPage = useQueryParameter('page', 1);
  const API_URL = config.get('API_URL');

  useEffect(() => {
    // Prevent search from being executed twice on startup.
    if (!initialized) {
      setInitialized(true);
      return;
    }

    setLoading(true);
    let url = `${API_URL}/${language}/search_api/${searchIndex}/search?filter[fulltext]=${currentQuery}&page=${currentPage - 1}&count=30`;
    if (currentType) {
      url += `&filter[type]=${currentType}`;
    }

    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        return fromJSOrdered(json);
      })
      .then((response) => {
        setLoading(false);
        setResults(Immutable.fromJS(response));
      })
      .catch((error) => {
        setLoading(false);
        setResults(Immutable.fromJS([]));
      });
  }, [searchIndex, currentQuery, currentType, currentPage, initialized, language, API_URL]);

  const doSearch = useCallback((_query, _type, _page) => {
    if (_query !== '') {
      history.push({
        pathname: searchPage,
        search: `?q=${_query}&filter[type]=${_type}&page=${_page}&count=10`,
      });
    }
  }, [history, searchPage]);

  return [
    results,
    currentQuery,
    currentType,
    loading,
    doSearch,
  ];
};

export default useSearchApi;
